var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectInNode)?_c('div',{staticClass:"area-map-border"},[_c('div',{staticClass:"area-map",attrs:{"id":"areaMap"}}),_c('div',{staticClass:"cancelBtn",on:{"click":_vm.cancelModal}},[_vm._v("X")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }